var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1704_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6235 5.13948C17.4165 4.36023 16.8067 3.74599 16.032 3.53749C14.6287 3.15948 9 3.15948 9 3.15948C9 3.15948 3.37125 3.15948 1.96725 3.53749C1.19325 3.74599 0.5835 4.35948 0.3765 5.13948C0 6.55248 0 9.49999 0 9.49999C0 9.49999 0 12.4475 0.3765 13.8605C0.5835 14.6397 1.19325 15.254 1.968 15.4625C3.37125 15.8405 9 15.8405 9 15.8405C9 15.8405 14.6288 15.8405 16.0328 15.4625C16.8068 15.254 17.4165 14.6405 17.6243 13.8605C18 12.4475 18 9.49999 18 9.49999C18 9.49999 18 6.55248 17.6235 5.13948ZM7.1595 12.1767V6.82324L11.8635 9.49999L7.1595 12.1767Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1704_166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon_video.76703751c91e5fa305c4c947245d9e49.svg";
export { ForwardRef as ReactComponent };